module.exports = __webpack_public_path__ + "static/media/xk.20ebf982.svg";